var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.821 8.16472C13.8539 7.32116 14.5132 6.03764 14.5132 4.6001C14.5132 2.05954 12.4537 0 9.91315 0C7.37258 0 5.31304 2.05954 5.31304 4.6001C5.31304 5.98165 5.92207 7.22094 6.88629 8.06416C3.41285 9.24169 0.913086 12.5291 0.913086 16.4005V18.4005H18.5135V16.4004C18.5135 12.6343 16.1476 9.42064 12.821 8.16472Z",
    fill: "#888888"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1962,
    cy: 15.9404,
    r: 5.05952,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7185 17.8283H16.71L18.577 13.6466L19.7811 14.1849L17.914 18.3638H17.9055L16.7553 19.344L16.7185 17.8283Z",
    fill: "#ED1C24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3676 12.7515L19.9172 12.9979C20.0985 13.0773 20.1778 13.2898 20.0985 13.4711L19.8662 13.9895L18.6621 13.4512L18.8944 12.9328C18.9738 12.7515 19.1862 12.6721 19.3676 12.7515Z",
    fill: "#ED1C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/editProfile.b45165eae04d61ab16c313cdb1672eb3.svg";
export { ForwardRef as ReactComponent };